import {useAiChat} from '@/ai-chat/providers/ai-chat.context';
import {LoadingStates} from '@Utils/loading.util';
import {closeAiActionLoadingModal, isCurrentModalSession, openEditorLoadingModalAndGetSessionId, showEditorReadyModal} from '@Components/ai-chat-window/lib/ai-action-loading-modal.library';
import {getPosterHashedIdForAiChatImageAsset} from '@Components/ai-chat-window/lib/chat-attachment-image.library';
import {GA4EventName} from '@Libraries/ga-events';

interface UseOpenChatImageInEditorProps {
  chatId: string;
}

interface UseOpenChatImageInEditor {
  openPosterInEditor: (hashedId: string) => Promise<void>;
}

export const useOpenChatImageInEditor = ({chatId}: UseOpenChatImageInEditorProps): UseOpenChatImageInEditor => {
  const {actions} = useAiChat();

  const openPosterInEditor = async (hashedId: string): Promise<void> => {
    actions.updateLoadingStatesForImageActions(chatId, hashedId, {
      openEditorLoadingState: LoadingStates.LOADING,
    });
    const sessionId = openEditorLoadingModalAndGetSessionId();

    try {
      const fetchedPosterHashedId = await getPosterHashedIdForAiChatImageAsset(hashedId);
      window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_OPEN_EDITOR);
      actions.updateLoadingStatesForImageActions(chatId, hashedId, {
        openEditorLoadingState: LoadingStates.LOADED,
      });

      if (!isCurrentModalSession(sessionId)) {
        return;
      }

      showEditorReadyModal(window.PMW.util.site_url(`posterbuilder/load/${fetchedPosterHashedId}`));
    } catch (e: unknown) {
      actions.updateLoadingStatesForImageActions(chatId, hashedId, {
        openEditorLoadingState: LoadingStates.NOT_LOADED,
      });
      closeAiActionLoadingModal();
      console.error(e);
    }
  };

  return {openPosterInEditor};
};

